import type { GetterClass } from '../../../models'

import { KpiEnum } from '../../../enums'

export class BrowseKpisGetter implements GetterClass {
  static execute(this: void): KpiEnum[] {
    return [
      KpiEnum.CLICKS,
      KpiEnum.FINDABILITY,
      KpiEnum.ADD2CART,
      KpiEnum.CHECKOUT,
      KpiEnum.VIEW,
      KpiEnum.POSITION_AVG,
    ]
  } // TODO: DATA 4868 - Add browse kpis to playboard schema
}
